import StoreUtil from '@/store/StoreUtil'

export default {
  USER: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.user, 'user'),
  USER_TYPE: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.user, 'userType'),
  FETCHING_USER: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'fetchingUser'
  ),
  CURRENT_PLAN: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'currentPlan'
  ),
  PROFILE: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.user, 'profile'),
  PAYMENT_METHOD: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'paymentMethod'
  ),
  EXCLUDED_SKILL_COUNT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'excludedSkillCount'
  ),
  IS_COACH: StoreUtil.prefixModuleKeys(StoreUtil.moduleNames.user, 'isCoach'),
  ACTING_AS_CLIENT: StoreUtil.prefixModuleKeys(
    StoreUtil.moduleNames.user,
    'actingAsClient'
  ),
}
